import { createLucideIcon } from 'lucide-react';
export const EmailIcon = createLucideIcon('email-icon', [
  [
    'path',
    {
      d: 'M2 5.5H22',
      key: '1uzj9x',
    },
  ],
  [
    'path',
    {
      d: 'M2 5.5L11.7297 12.5L22 5.5',
      key: '1adiwn',
    },
  ],
  [
    'path',
    {
      d: 'M2 5.5V18.5H22V5.5',
      key: '1b5pi4',
    },
  ],
]);
